import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsx, Fragment } from 'react/jsx-runtime';
import { Text } from '@dls/web';
import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import AlertBox from '../AlertBox/index.js';
import { useMessageBoundary } from './context/MessageBoundaryProvider.js';
const MessageBoundaryNotification = () => {
  const {
    messages,
    removeMessage
  } = useMessageBoundary();
  const [boundaryMessages, setBoundaryMessages] = useState(messages);
  const [consumedMessages] = useState(boundaryMessages);
  useEffect(() => {
    return () => {
      consumedMessages.map(message => removeMessage(message));
    };
  }, [consumedMessages, removeMessage]);
  const deleteCurrentMsg = useCallback(id => {
    setBoundaryMessages(boundaryMessages.filter(m => m.id !== id));
  }, [boundaryMessages]);
  const showingMessages = messages.length > 0 ? boundaryMessages.filter(m => messages.findIndex(ms => ms.id === m.id) > -1) : [];
  if (!showingMessages.length) return null;
  return /* @__PURE__ */jsx(Fragment, {
    children: showingMessages.map(message => /* @__PURE__ */jsx(MessageBoundaryMessageView, {
      message,
      deleteCurrentMsg: () => deleteCurrentMsg(message.id)
    }, message.id))
  });
};
const MessageBoundaryMessageView = _ref => {
  let {
    message,
    deleteCurrentMsg
  } = _ref;
  const {
    id,
    severity = "success",
    title,
    content
  } = message;
  const [out, setOut] = useState(false);
  useEffect(() => {
    let timeout;
    if (out) {
      timeout = setTimeout(() => {
        deleteCurrentMsg();
      }, DURATION);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [out, deleteCurrentMsg]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setOut(true);
    }, TIMEOUT);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return /* @__PURE__ */jsx(MessageBoxContainer, {
    className: out ? "out" : void 0,
    children: /* @__PURE__ */jsx(AlertBox, {
      severity,
      title,
      children: /* @__PURE__ */jsx(Text, {
        type: "smallBody",
        children: content
      })
    }, id)
  });
};
const DURATION = 500;
const TIMEOUT = 8e3;
const MessageBoxContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: max-height ", "ms cubic-bezier(0, 1, 0.5, 1);\n  overflow: hidden;\n  max-height: 1000px; //appropriate value\n\n  &.out {\n    max-height: 0;\n  }\n"])), DURATION);
export { DURATION, MessageBoxContainer, TIMEOUT, MessageBoundaryNotification as default };